import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "../context/AppContext";
import { resolveImg } from "../lib/api";
import { useBooking } from "../lib/bookingStore";
import { Button } from "./ui/button";

export default function ServiceCard({ service, index = 0 }) {
  const { t, lang, L } = useApp();
  const nav = useNavigate();
  const { addService, services } = useBooking();
  const inCart = services.find((s) => s.id === service.id);
  const name = L(service, "name");
  const disabled = service.active === false;

  const add = () => {
    addService(service);
    toast.success(lang === "ar" ? `تمت إضافة ${name}` : `${name} added`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
      className="group rounded-3xl overflow-hidden bg-card cb-card-shadow flex flex-col"
      data-testid={`service-card-${service.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={resolveImg(service.image_url)}
          alt={name}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {disabled && (
          <div className="absolute inset-0 bg-black/40 grid place-items-center">
            <span className="px-3 py-1 rounded-full bg-card text-sm font-medium">{t.services.unavailable}</span>
          </div>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="text-lg font-semibold text-foreground">{name}</h3>
        <p className="text-sm text-muted-foreground mt-1 line-clamp-2 flex-1">{L(service, "desc")}</p>
        <div className="flex items-center gap-4 mt-3 text-sm text-muted-foreground">
          <span className="inline-flex items-center gap-1">
            <Clock className="h-4 w-4" /> {service.duration} {t.common.minutes}
          </span>
          <span className="font-bold text-primary text-lg ms-auto">
            {service.price} <span className="text-sm font-medium">{t.common.sar}</span>
          </span>
        </div>
        <div className="flex gap-2 mt-4">
          <Button
            onClick={() => { if (!inCart) add(); nav("/book"); }}
            disabled={disabled}
            className="flex-1 rounded-full font-semibold"
            data-testid={`service-book-btn-${service.id}`}
          >
            {t.common.bookNow}
          </Button>
          <Button
            variant="outline"
            size="icon"
            onClick={add}
            disabled={disabled || !!inCart}
            className="rounded-full border-2 shrink-0"
            data-testid={`service-add-btn-${service.id}`}
            aria-label={t.common.addToBooking}
          >
            {inCart ? <Check className="h-5 w-5" /> : <Plus className="h-5 w-5" />}
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
